// extracted by mini-css-extract-plugin
module.exports = {"customIcon":"ExternalContentPage_customIcon__2NXwV"};